import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import BaseDetails from 'containers/Base/BaseDetails';
import {
  pendingCompanyActions,
  pendingCompanyPageActions,
  pendingCompanySelectors,
} from '../';
import { openDetails, toggleModal } from 'reducers/ui';
import OperationalAction from 'components/Operational/operationalAction';
import styles from 'containers/Pages/Tasks/Emergencies/Layouts/index.module.scss';
import { PAGE_URLS } from 'utils/constants';

const PendingCompanyDetails = ({ id, toggleEditMode, cancel, loading }) => {
  //------------------------------Selectors---------------------------------
  const details = useSelector(state =>
    pendingCompanySelectors.getPendingCompanyDetails(state),
  );
  const isPending = useSelector(state =>
    pendingCompanySelectors.isPendingStatus(state),
  );
  const title = useSelector(state =>
    pendingCompanySelectors.getPendingCompanyTitle(state),
  );
  //-----------------------Actions------------------------------------------
  const dispatch = useDispatch();
  const dispatchFetchDetails = useCallback(
    id => dispatch(pendingCompanyActions.fetchGridRowDetails({ id })),
    [dispatch],
  );
  const dispatchOpenDetails = useCallback(url => dispatch(openDetails(url)), [
    dispatch,
  ]);
  const dispatchClearDetails = useCallback(
    () => dispatch(pendingCompanyActions.setGridRowDetails({})),
    [dispatch],
  );
  const dispatchSetID = useCallback(
    id => {
      dispatch(pendingCompanyActions.setSelectedRowID(id));
    },
    [dispatch],
  );
  const dispatchToggleModal = useCallback(
    nameSpace => dispatch(toggleModal(nameSpace)),
    [dispatch],
  );
  const [showRejectConfirm, setRejectConfirm] = useState();
  const handleRejection = () => {
    dispatchRejectCompany(id);
    toggleRejectConfirm();
  };
  const dispatchRejectCompany = useCallback(
    id => {
      dispatch(pendingCompanyPageActions.rejectPendingCompany({ id }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch],
  );
  //------------------------------------------------------------------------
  const toggleRejectConfirm = () => {
    setRejectConfirm(!showRejectConfirm);
  };
  const btnRejectClick = () => {
    toggleRejectConfirm();
  };
  useEffect(() => {
    dispatchFetchDetails(id);
    dispatchOpenDetails(PAGE_URLS.PENDING_COMPANY.name);
    dispatchSetID(id);
    return () => {
      dispatchClearDetails();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatchFetchDetails]);
  const onEdit = () => {
    toggleEditMode();
    dispatchToggleModal(PAGE_URLS.PENDING_COMPANY.name);
  };
  const operationalComponent = () => {
    return (
      <div className={styles.operationalAction}>
        <OperationalAction
          type="button"
          item={{
            btnText: 'Reject',
            btnClickHandler: btnRejectClick,
          }}
          confirmPopup={{
            showConfirmPopup: showRejectConfirm,
            popupTitle: 'Reject Company',
            popupStatusMessage: '',
            popupActionMessage: 'Reject Company?',
            confirmBtnHandler: handleRejection,
            confirmBtnText: 'Reject',
            cancelBtnHandler: toggleRejectConfirm,
            cancelBtnText: 'Cancel',
            closePopupHandler: toggleRejectConfirm,
          }}
        />
      </div>
    );
  };
  return (
    <BaseDetails
      header={title}
      operationComponent={isPending && operationalComponent()}
      editable={isPending}
      details={details}
      cancel={cancel}
      loading={loading}
      onEdit={onEdit}
    />
  );
};
PendingCompanyDetails.propTypes = {
  cancel: PropTypes.func.isRequired,
  id: PropTypes.string,
  loading: PropTypes.bool,
  toggleEditMode: PropTypes.func,
};

export default PendingCompanyDetails;
